import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  DialogActions,
  Button,
  IconButton,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";

const styles = (theme) => ({
  dialog: {
    padding: "18px 24px",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    width: 400,
    userSelect: "none",
  },
  dialogTitle: {
    fontSize: theme.headerTextFontSize,
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.HeaderSelectedText,
    padding: 0,
  },
  dialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: "hidden",
    padding: "16px 0px",
  },
  redButton: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",
    margin: 0,
    background: theme.HeaderSelectedText,
    color: theme.ModalBGColor,
    minWidth: "47%",
  },
  button: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",
    margin: 0,
    minWidth: "47%",
    marginRight: "10px",
  },
  dialogAction: {
    justifyContent: "space-between",
    margin: 0,
    "&$actionButton": {
      paddingBottom: 0,
      paddingRight: 0,
    },
  },
  actionButton: {
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "right",
  },
  closeButton: { color: theme.iconColor, padding: "0px 10px" },
  dialogTitlestyle: {
    padding: 0,
    height: "20px",
  },
  warningIconClass: { color: theme.warningTextColor, paddingRight: "10px" },
});

const MergeStopAlert = (props) => {
  const { classes} = props;
  return (
    <Dialog
      open={true}
      aria-labelledby="MergeStopAlert-title"
      classes={{ paper: classes.dialog }}
      maxWidth="sm"
      onClose={props.onCancel}
    >
      <DialogTitle
        id="MergeStopAlert-title"
        classes={{ root: classes.dialogTitlestyle }}
        disableTypography
        onClose={props.onCancel}
      >
        <Grid container item xs={12}>
          <Grid item md={11} xs={10}>
            <span className={classes.dialogTitle}>
              Merge Stops Alert
            </span>
          </Grid>
          <Grid item md={1} xs={2} className={classes.closeIcon}>
            {props.onCancel ? (
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={props.onCancel}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Grid container spacing={24}>
          <Grid item xs={12} classes={{ root: classes.message }}>
            {props.inProgress ? (
              <span>Stops merging in progress.</span>
            ) : (
              <span>
                <WarningIcon
                  aria-label="Warning"
                  className={classes.warningIconClass}
                />
                The distance between selected stops is more than 1 mile. Do you
                want to continue merging?
              </span>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Grid container xs={12}>
          <Grid item xs={2}></Grid>
          <Grid
            item
            xs={10}
            classes={{ item: classes.actionButton }}
          >
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              className={classes.button}
              onClick={props.onCancel}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              className={classes.redButton}
              onClick={props.onConfirm}
            >
              Continue Merging
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(MergeStopAlert);
